export default __webpack_public_path__ + "static/media/video-2.caf92d02.mp4";